import { createStyles } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      position: 'relative',
    },
    locator: {},
    locatorValue: {
      position: 'relative',
      cursor: 'pointer',
      display: 'inline-flex',
      alignItems: 'center',
      gap: 4,
      '.loading-icon': {
        padding: 8,
        svg: {
          width: 16,
          height: 16,
        },
      },
    },
    selectTarget: {
      position: 'absolute',
      left: 0,
      bottom: 0,
      right: 0,
      [theme.fn.smallerThan('sm')]: {
        left: '50%',
        right: 'auto',
      },
    },
  }
})
